// extracted by mini-css-extract-plugin
export default {"formWrapper":"Login_formWrapper__10RSd","submitButton":"Login_submitButton__fMHAq"};